import { Switch } from "@mui/material";
import cn from "classnames";
import { useTranslate } from "@/hooks";
import { colorSecondary } from "@/constants/colors";
import { TCustomSwitchProps } from "./CustomSwitch.props";
import styles from "./CustomSwitch.module.scss";

const CustomSwitch = ({ labelLeft, labelRight, singleLabel = false, className, ...props }: TCustomSwitchProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<div className={cn(styles.switch, className)}>
			{labelLeft && translate(labelLeft)}
			<Switch
				{...props}
				sx={{
					"& .MuiSwitch-switchBase": {
						// для одиночного label (singleLabel) цвета в выключенном состоянии по дефолту
						color: singleLabel ? undefined : colorSecondary,
						"&.Mui-disabled": singleLabel ? {} : { color: colorSecondary, opacity: 0.7 }, // disabled
						"& + .MuiSwitch-track": singleLabel ? {} : { backgroundColor: colorSecondary }, // дорожка

						// при checked
						"&.Mui-checked": {
							color: colorSecondary,
							"&.Mui-disabled": { color: colorSecondary, opacity: 0.7 }, // disabled
							"& + .MuiSwitch-track": { backgroundColor: colorSecondary }, // дорожка
						},
					},
					...props.sx,
				}}
			/>
			{labelRight && translate(labelRight)}
		</div>
	);
};

export default CustomSwitch;
